export const customerClaimsColumns = [
  { key: 'periodYear', text: 'Year', width: '10%' },
  { key: 'principalAmount', text: 'Principal Amount', width: '20%' },
  { key: 'interest', text: 'Interest', width: '10%' },
  { key: 'interestAmount', text: 'Total Amount', width: '20%' },
  { key: 'status', text: 'Status', width: '15%' },
  { key: 'approvalStatus', text: 'Approval', width: '20%' },
  { key: 'options', text: '', width: '5%' }
];
